export class SearchDriverHistoryEntity {
  id?: string
  notifiedAt?: string
  notifiedBy?: {
    id?: string
    displayName?: string
  }
  driver?: {
    id?: string
    fullName?: string
  }
}
